<div class="card-body">
    <div class="search-component d-flex flex-wrap">
        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
            <div class="col-sm-11 d-flex gap-3 flex-column">
                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                    <div class="col-sm-2">
                        <InputTextNormal
                                :label="dataSearch.exchange_delivery_name.label"
                                :id="dataSearch.exchange_delivery_name.id"
                                :placeholder="dataSearch.exchange_delivery_name.placeholder"
                                :value-default="dataSearch.exchange_delivery_name.value"
                                @inputValue="onChange($event, dataSearch.exchange_delivery_name.id)"
                        >
                        </InputTextNormal>
                    </div>
<!--                    <div class="col-sm-2">-->
<!--                        <InputTextNormal-->
<!--                                :label="dataSearch.creator_name.label"-->
<!--                                :id="dataSearch.creator_name.id"-->
<!--                                :placeholder="dataSearch.creator_name.placeholder"-->
<!--                                :value-default="dataSearch.creator_name.value"-->
<!--                                @inputValue="onChange($event, dataSearch.creator_name.id)"-->
<!--                                :required="dataSearch.creator_name.required"-->
<!--                        ></InputTextNormal>-->
<!--                    </div>-->
                    <div class="col-sm-2">
                        <InputTextNormal
                                :label="dataSearch.partner_name.label"
                                :id="dataSearch.partner_name.id"
                                :placeholder="dataSearch.partner_name.placeholder"
                                :value-default="dataSearch.partner_name.value"
                                @inputValue="onChange($event, dataSearch.partner_name.id)"
                                :required="dataSearch.partner_name.required"
                        ></InputTextNormal>
                    </div>
                    <div class="col-sm-2">
                        <InputTextNormal
                                :label="dataSearch.partner_code.label"
                                :id="dataSearch.partner_code.id"
                                :placeholder="dataSearch.partner_code.placeholder"
                                :value-default="dataSearch.partner_code.value"
                                @inputValue="onChange($event, dataSearch.partner_code.id)"
                                :required="dataSearch.partner_code.required"
                        ></InputTextNormal>
                    </div>
                </div>
                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                    <div class="col-sm-2">
                        <SelectNormal
                                :label="dataSearch.status.label"
                                :id="dataSearch.status.id"
                                :placeholder="dataSearch.status.placeholder"
                                :value-default="dataSearch.status.value"
                                @inputValue="onChange($event, dataSearch.status.id)"
                                :required="dataSearch.status.required"
                                :options="dataSearch.status.options"
                        ></SelectNormal>
                    </div>
                    <div class="col-sm-2">
                        <InputDateTimeNormal
                                :label="dataSearch.delivery_date.label"
                                :id="dataSearch.delivery_date.id"
                                :placeholder="dataSearch.delivery_date.placeholder"
                                :value-default="dataSearch.delivery_date.value"
                                @inputValue="onChange($event, dataSearch.delivery_date.id)"
                                :required="dataSearch.delivery_date.required"
                        ></InputDateTimeNormal>
                    </div>
                    <div class="col-sm-2">
                        <InputDateTimeNormal
                                :label="dataSearch.time_created.label"
                                :id="dataSearch.time_created.id"
                                :placeholder="dataSearch.time_created.placeholder"
                                :value-default="dataSearch.time_created.value"
                                @inputValue="onChange($event, dataSearch.time_created.id)"
                                :required="dataSearch.time_created.required"
                        ></InputDateTimeNormal>
                    </div>
                    <div class="col-sm-2">
                        <InputDateTimeNormal
                                :label="dataSearch.time_approved.label"
                                :id="dataSearch.time_approved.id"
                                :placeholder="dataSearch.time_approved.placeholder"
                                :value-default="dataSearch.time_approved.value"
                                @inputValue="onChange($event, dataSearch.time_approved.id)"
                                :required="dataSearch.time_approved.required"
                        ></InputDateTimeNormal>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-sm-12 d-flex justify-content-between mt-4">
        <div class="action d-flex align-items-center gap-3">
            <div class="total">
                {{ CommonText.TOTAL_RECORD(listDeliveries.length, paginate.itemCount) }}
            </div>
            <div class="dropdown-action">
                <SelectNormal
                        :label="selectAction.label"
                        :id="selectAction.id"
                        :placeholder="selectAction.placeholder"
                        :value-default="selectAction.value"
                        @inputValue="onChangeAction($event)"
                        :required="selectAction.required"
                        :options="selectAction.options"
                ></SelectNormal>
            </div>
        </div>
        <div class="d-flex align-items-center gap-2">
            <span>Hiển thị</span>
            <SelectNormal
                    :label="selectLimit.label"
                    :id="selectLimit.id"
                    :placeholder="selectLimit.placeholder"
                    :value-default="selectLimit.value"
                    @inputValue="onChangeLimit($event)"
                    :required="selectLimit.required"
                    :options="selectLimit.options"
            >
            </SelectNormal>
            <span> kết quả trên trang</span>
        </div>
    </div>
    <div class="list-partners-component">
        <table class="table">
            <thead>
            <tr>
                <th><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }" v-html="header.label"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="listDeliveries.length > 0" v-for="delivery in listDeliveries" :key="delivery.id">
                <td><InputCheckboxOne :id="delivery.id" :value-default="checkItems[delivery.id]" @inputValue="onChangeSelectItem($event, delivery.id)" :checked="checkItems[delivery.id]"></InputCheckboxOne></td>
                <td class="text-center"><div class="label-underline" @click="redirectToDetail(delivery.id)">{{delivery.delivery_name}} <span class="tooltip">{{delivery.delivery_name}}</span></div></td>
                <td class="text-center">{{delivery.m_company_receiver ? delivery.m_company_receiver.company_zip + ' - ' + delivery.m_company_receiver.company_name : ''}}</td>
                <td class="text-center">{{CommonService.formatPrice(delivery.sum_amount, 'VND')}}</td>
                <td class="text-center">{{CommonService.formatPrice(delivery.sum_tax_included, 'VND')}}</td>
                <td class="text-center">
                    <LabelStatus
                            :label="CommonService.compareStatusDeliveryLabel(delivery.status)"
                            :background_color="CommonService.compareStatusDeliveryBackground(parseInt(delivery.status))">
                    </LabelStatus>
                </td>
                <td class="text-center">{{CommonService.formatDate(delivery.created_at)}}</td>
                <td class="text-center">{{CommonService.formatDate(delivery.approved_date)}}</td>
                <td class="text-center">{{CommonService.formatDate(delivery.delivery_date)}}</td>
                <td class="text-center">
                    <ButtonExportBillComponent :label="labelButtonExportBill" @click="exportBillDelivery(delivery.id)"></ButtonExportBillComponent>
                </td>
            </tr>
            <tr v-else>
                <td colspan="9" class="text-center">Không có dữ lệu được tìm thấy!</td>
            </tr>
            </tbody>
        </table>
    </div>
    <PaginateComponent :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)" v-if="paginate.itemCount > paginate.take"></PaginateComponent>
</div>

<ExportBillComponent v-if="isShowBill" :billData="dataBillToPrint"/>
